// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const stepperClasses = {
  completedContent: "qui-stepper__completed-content",
  content: "qui-stepper__content",
  hint: "qui-stepper__hint",
  indicator: "qui-stepper__indicator",
  indicatorIcon: "qui-stepper__indicator-icon",
  item: "qui-stepper__item",
  itemIcon: "qui-stepper__item-icon",
  itemNumber: "qui-stepper__item-number",
  label: "qui-stepper__label",
  list: "qui-stepper__list",
  nextTrigger: "qui-stepper__next-trigger",
  prevTrigger: "qui-stepper__prev-trigger",
  root: "qui-stepper__root",
  separator: "qui-stepper__separator",
  trigger: "qui-stepper__trigger",
} as const
